module.exports = __webpack_public_path__ + "static/img/01.cb679494.png";